import { WidgetFactoryClass } from 'extensions/widget/factories/widget-components-factory';
import { insightsSlice } from 'features/insights/store/insights-slice';

export const insightsReducer = {
    poi: insightsSlice.reducer,
};

export const InsightsPageWidgetFactory = new WidgetFactoryClass();
